import { logUsage } from 'owa-analytics';

type AppDefinitionTelemetry = {
    appId: string;
    step: 'queryAppdefinition' | 'getAppDefinition';
    context?: 'ResponseEmpty' | 'Apollo_Unavailable';
};

export function log(params: AppDefinitionTelemetry) {
    logUsage('AppDefinitionsQuery_Usage', params);
}
